export default __webpack_public_path__ + "static/AD_9726_rgb-2eb0c1b12187c19fc8da3a09a652aef8.jpg";